import React, { useEffect, useState } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import Axios from "axios";

function ChatTeleconsultoria({ socket, username, room }) {
  const [currentMessage, setCurrentMessage] = useState("");
  const [messageList, setMessageList] = useState([]);
  const roomId = room;

  const sendMessage = async () => {
    if (currentMessage !== "") {
      const messageData = {
        room: room,
        author: username,
        message: currentMessage,
        time:
          new Date(Date.now()).getHours() +
          ":" +
          new Date(Date.now()).getMinutes(),
      };
      Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/salvaMensagemChatTeleconsultoria`,
        {
          id: room,
          data: messageData,
        }
      );
      await socket.emit("send_message", messageData);
      setMessageList((list) => [...list, messageData]);
      setCurrentMessage("");
    }
  };

  function verificaMensagem() {
    socket.emit("join_room", room);
    Axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/retornaMensagemChatTeleconsultoria`,
      {
        id: roomId,
      }
    ).then((response) => {
      if (response.data[0]) {
        for (let i = 0; i < response.data.length; i++) {
          setMessageList((list) => [
            ...list,
            JSON.parse(response.data[i].data),
          ]);
        }
      }
    });
  }

  useEffect(() => {
    verificaMensagem();
    socket.on("receive_message", (data) => {
      setMessageList((list) => [...list, data]);
    });
  }, [socket]);

  return (
    <div className="chat-window">
      <div className="chat-header">
        <p></p>
      </div>
      <div className="chat-body">
        <ScrollToBottom
          className="message-container"
          initialScrollBehavior="auto"
        >
          {messageList.map((messageContent) => {
            return (
              <div
                className="message"
                id={username === messageContent.author ? "you" : "other"}
              >
                <div>
                  <div className="message-content">
                    <p>{messageContent.message}</p>
                  </div>
                  <div className="message-meta">
                    <p id="time">{messageContent.time}</p>
                    <p id="author">{messageContent.author}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </ScrollToBottom>
      </div>
      <div className="chat-footer">
        <input
          type="text"
          value={currentMessage}
          placeholder="Insira sua mensagem..."
          onChange={(event) => {
            setCurrentMessage(event.target.value);
          }}
          onKeyPress={(event) => {
            event.key === "Enter" && sendMessage();
          }}
        />
        <button onClick={sendMessage}>&#9658;</button>
      </div>
    </div>
  );
}

export default ChatTeleconsultoria;
